import React, { useState, useRef } from 'react';
import * as XLSX from 'xlsx';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Toast } from 'primereact/toast';
import { createBulkMedicalCases, fetchCompanyClientId } from '../services/massiveCase';
import { fetchUploadHistory2, saveBulkUploadHistory } from '../services/uploadCase';
import './masive.css';
import { ProgressSpinner } from "primereact/progressspinner";
import { Checkbox } from 'primereact/checkbox';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { UserRole } from "../constants";
import { exportCombinedToExcel, exportCombinedToPDF } from './export';
import { processExcelData, processSingleCase, formatDate } from './processing';

const userName = localStorage.getItem("username");

 
function ExcelMedicalCasesUploader() {
  const [excelData, setExcelData] = useState([]);
  const [headers, setHeaders] = useState([]);
  const [cases, setCases] = useState([]);
  const [isProcessing, setIsProcessing] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);
  const [dragActive, setDragActive] = useState(false);
  const [fileName, setFileName] = useState('');
  const fileInputRef = useRef(null);
  const [visibleConfirmDialog, setVisibleConfirmDialog] = useState(false);
  const [errorDetails, setErrorDetails] = useState([]);
  const toast = useRef(null);
  const [visibleDialog, setVisibleDialog] = useState(false);
  const [selectedCompanies, setSelectedCompanies] = useState([]);
  const [availableCompanies, setAvailableCompanies] = useState([]);
  const [duplicateCases, setDuplicateCases] = useState([]);
  const [expandedCases, setExpandedCases] = useState({});
  const [duplicateDialogVisible, setDuplicateDialogVisible] = useState(false);

  const [isSubmitting, setIsSubmitting] = useState(false);
  // Agrega esto con los otros useState
  const [filterUser, setFilterUser] = useState('');
  const [filterDate, setFilterDate] = useState('');
 // Paginación
  const [currentPage, setCurrentPage] = useState(1); // ✅ Aquí sí es válido
  
  const handleExport = (format) => {
    if (format === 'excel') {
      exportCombinedToExcel(selectedUpload, userName);
    } else {
      exportCombinedToPDF(selectedUpload);
    }
  };

  const handleDownload = (companyId) => {
    let templateName;

    switch (companyId) {
      case 1:
        templateName = 'plantilla_pdvsa.xlsm';
        break;
      case 4:
        templateName = 'plantilla_cvglaboratorio.xlsm';
        break;
      default:
        toast.current.show({
          severity: 'warn',
          summary: 'Advertencia',
          detail: 'No hay plantilla disponible para esta compañía.',
        });
        return;
    }

    const link = document.createElement('a');
    link.href = `/archivo/${templateName}`;
    link.download = templateName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    toast.current.show({
      severity: 'success',
      summary: 'Éxito',
      detail: `Plantilla descargada con exito (${templateName})`,
      life: 3000,
    });
  };
 
 
  const [uploadHistory, setUploadHistory] = useState([]);
  const [showHistoryModal, setShowHistoryModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [selectedUpload, setSelectedUpload] = useState(null);
  const [modalView, setModalView] = useState('history'); // 'history' | 'details'

  const handleShowDetails = (item) => {
  try {
    const parsedDetails = item.details ? JSON.parse(item.details) : { created: [], failed: [] };
    setSelectedUpload({
      ...item,
      details: parsedDetails
    });
    setModalView('details'); // Cambia la vista del modal
  } catch (err) {
    toast.current.show({ 
      severity: "error", 
      summary: "Error", 
      detail: "No se pudieron cargar los detalles." 
    });
  }
};

  const handleFetchHistory = async () => {
    setLoading(true);
    setError(null);
    
    try {
      const data = await fetchUploadHistory2();
      console.log("✅ Historial recibido del backend:", data);
      
      // Actualizar ambos estados
      setUploadHistory(data.results || []);  // Guardar los datos en el estado
      setShowHistoryModal(true);  // Mostrar el modal
      
    } catch (err) {
      console.error("❌ Error al cargar historial:", err.message);
      setError("No se pudo cargar el historial. Inténtalo más tarde.");
    } finally {
      setLoading(false);
    }
};


  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(true);
  };

const handleDragLeave = (e) => {
  e.preventDefault();
  e.stopPropagation();
  setDragActive(false);
};

const handleDrop = (e) => {
  e.preventDefault();
  e.stopPropagation();
  setDragActive(false);
  setErrorDetails([]); 

  if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
    const file = e.dataTransfer.files[0];
    setFileName(file.name);
    const event = { target: { files: e.dataTransfer.files } };
    handleFileUpload(event);
  }
};
  
  
  const queryClient = useQueryClient();
 const parseErrorMessage = (error) => {
  

  // 1. Si ya es un objeto (el caso ideal)
  if (typeof error === 'object' && error !== null) {
    // Primero, busca el mensaje más específico en 'detail_message'
    if (error.detail_message?.[0]?.string) {
      return error.detail_message[0].string;
    }
    // Si no, busca en 'message'
    if (error.message?.[0]?.string) {
      return error.message[0].string;
    }
    // Si 'message' es solo un string
    if (typeof error.message === 'string') {
        return error.message;
    }
  }

  // 2. Si es un string con el formato "ErrorDetail(...)"
  if (typeof error === 'string') {
    try {
      // Intenta convertir el string a un objeto JSON válido
      // Esta es una versión más segura que la tuya para evitar errores
      const jsonStr = error.replace(/ErrorDetail\(([^)]+)\)/g, (match, group) => {
        const props = group.replace(/'/g, '"').replace(/(\w+)=/g, '"$1":');
        return `{${props}}`;
      }).replace(/'/g, '"'); // Reemplaza comillas simples restantes en el objeto principal

      const parsed = JSON.parse(jsonStr);

      // Una vez parseado, aplica la misma lógica que en el paso 1
      if (parsed.detail_message?.[0]?.string) {
        return parsed.detail_message[0].string;
      }
      if (parsed.message?.[0]?.string) {
        return parsed.message[0].string;
      }
    } catch (e) {
      // Si el parseo falla, devuelve el string original o un mensaje genérico
      console.error("Fallo al parsear el string de error:", e);
      return error; // A menudo el string original es suficiente
    }
  }

  // 3. Si todo lo demás falla
  return "Error desconocido";
};

const massiveCaseMutation = useMutation({
  mutationFn: createBulkMedicalCases,
  onSuccess: ({ details }) => {
    console.log("✅ Casos masivos creados exitosamente:", details);
    queryClient.invalidateQueries({ queryKey: ["medicalCases"] });

    const successful = details.created || [];
    const failed = details.failed || [];
    const totalCases = cases.length;

    let severity, summary, detail, status;

    if (successful.length > 0 && failed.length === 0) {
      severity = "success";
      summary = "¡Éxito total!";
      detail = `✅ Se crearon correctamente todos los ${successful.length} casos. Para ver el detalle completo de cada caso, por favor haz clic en el botón "Ver Historial". IDs generados: ${successful.map(c => c.id).join(", ")}`;
      status = "completed";
      setErrorDetails([]);
    } else if (failed.length > 0 && successful.length === 0) {
      severity = "warn";
      summary = "Todos los casos fallaron";
      status = "failed";
      //const errorMessages = failed.map(f =>
      //  `• Caso ${f.index + 1}: ${parseErrorMessage(f.error)}`
      //).join("\n");
      //detail = [
      //  `⚠️ Todos los casos fallaron.`,
      //  "Motivos:",
      //  ...errorMessages.split("\n")
      //].join("\n");
      // Mensaje simple para Toast
      detail = "⚠️ Uno o más pacientes ya tienen casos médicos pendientes.";

      setErrorDetails(
        failed.map(f => ({
          caseNumber: f.index + 2,
          patientCi: cases[f.index]?.processedData?.patient?.ci || 'N/A',
          errorMessage: parseErrorMessage(f.error),
          rawData: cases[f.index]?.rawData || {}
        }))
      );
      
    } else {
      severity = "warn";
      summary = "Resultado parcial";
      status = "completed";
      const errorMessages = failed.map(f =>
        `• Caso ${f.index + 1}: ${parseErrorMessage(f.error)}`
      ).join("\n");
      detail = [
        `✅ ${successful.length} CASOS CREADOS ,⚠️ ${failed.length} fallidos.`,
        "Motivos de fallo:",
        ...errorMessages.split("\n")
      ].join("\n");

      setErrorDetails(
      failed.map(f => {
        const parsedError = parseErrorMessage(f.error);

        return {
          caseNumber: f.index + 2,
          patientCi: cases[f.index]?.processedData?.patient?.ci || 'N/A',

          errorMessage: parsedError.message,
       
          rawData: cases[f.index]?.rawData || {}
        };
      })
    );
    }

    toast.current.show({ severity, summary, detail, life: 10000 });

    // Preparar historial
    const historyEntry = {
      file_name: fileName,
      total_cases: totalCases,
      successful_cases: successful.length,
      failed_cases: failed.length,
      status: status,
      user: userName,
      details: {
        created: successful.map(c => ({
          id: c.id,
          ci: c.patient.ci,
          name: c.patient.name,
          diagnosis: c.diagnosis.join(', '),
          medical_center: c.medical_center
        })),
        failed: failed.map(f => ({
          index: f.index,
          error: parseErrorMessage(f.error),
          patient_ci: cases[f.index]?.processedData?.patient?.ci || 'N/A',
          patient_name: cases[f.index]?.processedData?.patient?.name || 'N/A'
        }))
      }
    };

    // Guardar historial en el backend
    saveBulkUploadHistory({
      ...historyEntry,
      details: JSON.stringify(historyEntry.details)
    })
      .then(() => {
        queryClient.invalidateQueries(['uploadHistory']);
      })
      .catch(err => {
        toast.current.show({
          severity: "warn",
          summary: "Advertencia",
          detail: "No se pudo guardar el historial.",
          life: 5000,
        });
        console.error("Error guardando historial:", err);
      });

    // Navegación según resultado
    
    if (severity === "warn"){
      setVisibleConfirmDialog(false);
      setCurrentStep(3);

      const role = localStorage.getItem("role");

      if (role === UserRole.LABORATORY) {
        const duplicates = failed.filter(f => 
            parseErrorMessage(f.error).toLowerCase().includes("pendiente")
          );
          
          if (duplicates.length > 0) {
            setDuplicateCases(duplicates.map(f => ({
              index: f.index,
              caseNumber: f.index + 1,
              patientCi: cases[f.index]?.processedData?.patient?.ci || 'N/A',
              patientName: cases[f.index]?.processedData?.patient?.name || 'N/A',
              error: parseErrorMessage(f.error),
              processedData: cases[f.index]?.processedData,
              selected: false
            })));
            setDuplicateDialogVisible(true); // Mostrar el diálogo
          }
        
      }
        
      
    } else {
      resetForm();
    }
  },
  onError: (error, details) => {
    let severity = "error";
    let summary = "Error";
    let detail = "Ocurrió un error al procesar los casos.";
     console.log("Respuesta completa del servidor:", error.data, details.error, details);
    
    toast.current.show({
      severity,
      summary,
      detail,
      life: 10000,
    });
  }
});

// Función para manejar la selección
  const handleDuplicateSelection = (index) => {
    setDuplicateCases(prev => prev.map((item, i) => 
      i === index ? { ...item, selected: !item.selected } : item
    ));
  };

  // Función para crear los casos seleccionados
  const createSelectedDuplicates = () => {
    const casesToCreate = duplicateCases
      .filter(item => item.selected)
      .map(item => ({
        ...item.processedData,
        duplicate: true
      }));

    if (casesToCreate.length > 0) {
      massiveCaseMutation.mutate(casesToCreate);
    }
    setDuplicateDialogVisible(false);
  };

  // Footer del diálogo
  const duplicateDialogFooter = (
    <div className='footerdg'>
      <Button 
        label="Crear seleccionados" 
        icon="pi pi-check" 
        onClick={createSelectedDuplicates} 
        disabled={!duplicateCases.some(item => item.selected)}
        autoFocus 
      />
      <Button 
        label="Omitir todos" 
        icon="pi pi-times" 
        onClick={() => {
          setDuplicateDialogVisible(false);
          resetForm();
        }}
        className="p-button-text" 
        style={{ background: 'red', color: 'white', right: '0' }}
      />
      
    </div>
  );

  const resetForm = () => {
    setFileName('');
    setExcelData([]);
    setHeaders([]);
    setCases([]);
    setCurrentStep(1);
    setErrorDetails([]);
  };

  const handleFileUpload = (e) => {
    setErrorDetails([]);
  
  
    const file = e.target.files[0];
    setFileName(file.name);
    setIsProcessing(false);

    const reader = new FileReader();
    
    reader.onload = (e) => {
      const workbook = XLSX.read(e.target.result, { type: 'binary' });
      const worksheet = workbook.Sheets['Resultados'] || workbook.Sheets[workbook.SheetNames[0]];
      
      if (!worksheet) {
        toast.current.show({
          severity: 'error',
          summary: 'Error',
          detail: 'No se encontró la hoja "Resultados"',
        });
        return;
      }
      
      const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
      const headers = jsonData[0];
      const rows = jsonData.slice(1).filter(row => row.length > 0);
      
      const formattedData = rows.map(row => {
        const obj = {};
        headers.forEach((header, index) => {
          obj[header] = row[index];
        });
        return obj;
      });
      
      setHeaders(headers);
      setExcelData(formattedData);
      const processedCases = processExcelData(formattedData, formatDate);
      setCases(processedCases);
      setCurrentStep(2);
    };
    
    reader.readAsBinaryString(file);
  };


  const updateCaseData = (index, field, value) => {
    setCases(prev => {
      const newCases = [...prev];
      
      // Actualizamos tanto los datos crudos como los procesados
      newCases[index] = {
        ...newCases[index],
        rawData: {
          ...newCases[index].rawData,
          [field]: value
        },
        processedData: processSingleCase({
          ...newCases[index].rawData,
          [field]: value
        },formatDate)
      };
      
      return newCases;
    });
  };
  

  const handleSubmit = () => {
    // Validación exhaustiva
    const hasErrors = cases.some((caseItem, index) => {
      const { holder, patient, diagnosis, medical_center, subsidiary } = caseItem.processedData;
      
      if (!holder.ci || !/^V\d{6,8}$/.test(holder.ci)) {
        toast.current.show({
          severity: 'error',
          summary: 'Error',
          detail: `Caso ${index + 1}: error en CI del titular`,
        });
        return true;
      }
      
      if (!patient.name) {
        toast.current.show({
          severity: 'error',
          summary: 'Error',
          detail: `Caso ${index + 1}: Nombre del paciente requerido`,
        });
        return true;
      }
      
      
      if (!holder.phone || holder.phone.length < 10) {
        toast.current.show({
          severity: 'error',
          summary: 'Error',
          detail: `Caso ${index + 1}: Teléfono no válido`,
        });
        return true;
      }
      
      if (!diagnosis) {
        toast.current.show({
          severity: 'error',
          summary: 'Error',
          detail: `Caso ${index + 1}: Diagnóstico requerido`,
        });
        return true;
      }
      
      if (!medical_center) {
        toast.current.show({
          severity: 'error',
          summary: 'Error',
          detail: `Caso ${index + 1}: Clínica requerida`,
        });
        return true;
      }
      
      if (!subsidiary) {
        toast.current.show({
          severity: 'error',
          summary: 'Error',
          detail: `Caso ${index + 1}: Filial requerida`,
        });
        return true;
      }
      
      return false;
    });
    
    if (hasErrors) return;
    
    // Mostrar spinner antes de enviar
    setIsSubmitting(true);
    // Preparar datos para enviar
    const casesToSend = cases.map(c => c.processedData);
    
    // Mostrar en consola para depuración
    console.log("Datos a enviar al API:", casesToSend.slice(0, 1));
    
    // Enviar al API
    //massiveCaseMutation.mutate(casesToSend);
    massiveCaseMutation.mutate(casesToSend, {
    onSettled: () => {
      setIsSubmitting(false); // Ocultar spinner cuando termine
    },
  });
  };

  // Función para renderizar el paso 2 con capacidad de edición
  const renderEditStep = () => {
  if (cases.length === 0) return null;

  const fields = [
    { key: 'CI_TITULAR', label: 'CI Titular', type: 'text' },
    { key: 'NOMBRE_TITULAR', label: 'Nombre Titular', type: 'text' },
    { key: 'CI_PACIENTE', label: 'CI Paciente', type: 'text' },
    { key: 'NOMBRE_PACIENTE', label: 'Nombre Paciente', type: 'text' },
    { key: 'TELEFONO', label: 'Teléfono', type: 'text' },
    { key: 'TELEFONO_ALTERNO', label: 'Teléfono Alterno', type: 'text' },
    { key: 'FECHA_NACIMIENTO', label: 'Fecha Nacimiento', type: 'text' },
    { key: 'SEXO', label: 'Sexo', type: 'text' }, //options: ['M', 'F']
    { key: 'FILIAL', label: 'Filial', type: 'text' },
    { key: 'CLINICA', label: 'Clínica', type: 'text' },
    { key: 'DIAGNOSTICO', label: 'Diagnóstico', type: 'text' },
    { key: 'REQUERIMIENTOS', label: 'Requerimientos', type: 'text' },
  ];

  return (
    <div style={{ marginTop: '20px' }}>
      <h2>Validar y Editar Datos</h2>
      <p>Total de casos: {cases.length}</p>

      {/* Tabla con clase CSS */}
      <div className="edit-table-container">
        <table className="edit-table">
          <thead>
            <tr>
              <th>#</th>
              {fields.map(field => (
                <th key={field.key}>{field.label}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {cases.map((caseItem, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                {fields.map(field => (
                  <td key={field.key}>
                    {field.type === 'select' ? (
                      <select
                        value={caseItem.rawData[field.key] || ''}
                        onChange={(e) => updateCaseData(index, field.key, e.target.value)}
                      >
                        {field.options.map(option => (
                          <option key={option} value={option}>
                            {option}
                          </option>
                        ))}
                      </select>
                    ) : (
                      <input
                        type={field.type}
                        value={field.key === 'FECHA_NACIMIENTO' ? formatDate(caseItem.rawData[field.key]) : caseItem.rawData[field.key]}
                        onChange={(e) => updateCaseData(index, field.key, e.target.value)}
                        style={{ width: '100%', padding: '5px' }}
                      />
                    )}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Botones de navegación */}
      <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px' }}>
        <button 
            onClick={() => {
              resetForm();
              setCurrentStep(1);
            }}
            style={{
              padding: '10px 20px',
              backgroundColor: '#6c757d',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            Volver
          </button>
        <button 
          onClick={() => setCurrentStep(3)}
          style={{
            padding: '10px 20px',
            backgroundColor: '#68c6ff',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer'
          }}
        >
          Continuar
        </button>
      </div>
    </div>
  );
};

  const confirmDialogFooter = (
    <div>
      <Button 
        label="Cancelar" 
        icon="pi pi-times" 
        onClick={() => setVisibleConfirmDialog(false)} 
        className="p-button-textg" 
      />
      <Button 
        label="Confirmar" 
        icon="pi pi-check" 
        onClick={() => {
          setVisibleConfirmDialog(false);
          handleSubmit();
        }} 
        autoFocus 
      />
    </div>
  );

  const renderHistoryContent = () => {
      if (loading) return (
        <div className="text-center">
          <ProgressSpinner />
          <p>Cargando historial...</p>
        </div>
      );
      
      if (error) return (
        <div className="p-message p-message-error">
          {error.message || "Error al cargar el historial"}
        </div>
      );

    if (!uploadHistory.length) return <p>No hay registros aún.</p>;

    // Aplicar filtros
    const filteredHistory = uploadHistory.filter(item => {
      const matchUser = !filterUser || item.user?.toLowerCase().includes(filterUser.toLowerCase());
      
      const itemDate = item.upload_date ? new Date(item.upload_date).toISOString().split('T')[0] : '';
      const matchDate = !filterDate || itemDate === filterDate;

      return matchUser && matchDate;
    });
//Paginacion
  const itemsPerPage = 10; // Puedes cambiar a 10 si prefieres
  const totalPages = Math.ceil(filteredHistory.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredHistory.slice(indexOfFirstItem, indexOfLastItem);

      return (
        
        <div className="table-responsive">
          <table className="p-datatable-tableg">
            <thead>
              <tr>
                <th>Fecha</th>
                <th>Archivo</th>
                <th>Estado</th>
                <th>Total</th>
                <th>Éxitos</th>
                <th>Fallos</th>
                <th>Creador</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
            {currentItems.map((item) => (
              <tr key={item.id || Math.random()}>
                <td>{item.upload_date ? new Date(item.upload_date).toLocaleDateString() : 'N/A'}</td>
                <td>{item.file_name || 'Sin nombre'}</td>
                <td>
                  <span className={`status-tag ${item.status === 'failed' ? 'failed' : item.status === 'completed' ? 'completed' : 'failed'}`}>
                    {item.status === 'failed' ? 'Fallido' : item.status === 'completed' ? 'Completado' : 'Fallido'}
                  </span>
                </td>
                <td>{item.total_cases || 0}</td>
                <td>{item.successful_cases || 0}</td>
                <td>{item.failed_cases || 0}</td>
                <td>{item.user}</td>
                <td>
                  <button
                    className="p-button-textg"
                    onClick={() => handleShowDetails(item)}
                  >
                    Detalle
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
          </table>

          {/* Paginación */}
          {totalPages > 1 && (
            <div style={{ display: 'flex', justifyContent: 'center', gap: '10px', marginTop: '1rem' }}>
              <Button 
                label="← Anterior"
                icon="pi pi-angle-left"
                onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
                className="p-button-text"
              />
              <span style={{ alignSelf: 'center' }}>Página {currentPage} de {totalPages}</span>
              <Button 
                label="Siguiente →"
                icon="pi pi-angle-right"
                iconPos="right"
                onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                disabled={currentPage === totalPages}
                className="p-button-text"
              />
            </div>
          )}
        </div>
      );
  };

  function extrationPrincipalmsj(msj) {
    // Buscamos el índice del primer ":"
    const indexmsj = msj.indexOf(":");

    // Si se encuentra, devolvemos la parte antes de ese ":"
    if (indexmsj !== -1) {
        return msj.slice(0, indexmsj).trim();
    }

    // Si no se encuentra, devolvemos el mensaje completo o un valor por defecto
    return msj.trim();
}

  const renderDetailsContent = () => {
    if (!selectedUpload) return <p>No hay datos seleccionados.</p>;
    
    const { created = [], failed = [] } = selectedUpload.details;

    return (
      <div>

        {/* Botones de exportación combinada */}
        <div className="export-buttons" style={{ 
          marginBottom: '20px', 
          display: 'flex', 
          gap: '20px',
          justifyContent: 'right',
          padding: '15px',
          backgroundColor: '#f8f9fa',
          borderRadius: '6px'
        }}>
          <Button 
            label="Exportar a Excel" 
            icon="pi pi-file-excel" 
            className="p-button-success" 
            onClick={() => handleExport('excel')}
            tooltip="Descargar reporte completo en Excel"
            tooltipOptions={{ position: 'bottom' }}
          />
          <Button 
            label="Exportar a PDF" 
            icon="pi pi-file-pdf" 
            className="p-button-danger" 
            onClick={() => handleExport('pdf')}
            tooltip="Descargar reporte completo en PDF"
            tooltipOptions={{ position: 'bottom' }}
          />
        </div>
        {/* Casos Creados */}
        <h3>Casos Creados ({created.length})</h3>
        {created.length > 0 ? (
          <table className="p-datatable-tableg">
            <thead>
              <tr>
                <th>ID</th>
                <th>Cédula</th>
                <th>Paciente</th>
                <th>Diagnóstico</th>
                <th>Clínica</th>
              </tr>
            </thead>
            <tbody>
              {created.map((caseItem, idx) => (
                <tr key={`created-${idx}`}>
                  <td>{caseItem.id}</td>
                  <td>{caseItem.ci}</td>
                  <td>{caseItem.name}</td>
                  <td>{caseItem.diagnosis}</td>
                  <td>{caseItem.medical_center}</td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p>No hay casos creados.</p>
        )}

        {/* Casos Fallidos */}
        {failed.length > 0 && (
          <>
            <h3>Casos Fallidos ({failed.length})</h3>
            <table className="p-datatable-tableg">
              <thead>
                <tr>
                  <th>Cédula</th>
                  <th>Nombre Paciente</th>
                  <th>Motivo de falla</th>
                </tr>
              </thead>
              <tbody>
                {failed.map((fail, idx) => (
                  <tr key={`failed-${idx}`}>
                    <td>{fail.patient_ci || 'N/A'}</td>
                    <td>{fail.patient_name || 'N/A'}</td>
                    <td>{extrationPrincipalmsj(fail.error)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </>
        )}
      </div>
    );
  };

// Función mejorada para manejar el formato exacto de tus mensajes
const formatPendingCases = (errorMessage) => {
  if (!errorMessage || typeof errorMessage !== 'string') {
    return "No hay información de casos pendientes";
  }

  // Verificar que contenga la estructura esperada
  if (!errorMessage.includes('El paciente ya tiene') || !errorMessage.includes('pendientes:')) {
    return "No se encontraron casos pendientes";
  }

  try {
    // Extraer desde donde comienzan los casos
    const casesStart = errorMessage.indexOf('pendientes:') + 'pendientes:'.length;
    let casesSection = errorMessage.slice(casesStart).trim();

    // Reemplazar múltiples saltos de línea por uno solo
    casesSection = casesSection.replace(/\n{2,}/g, '\n');

    // Dividir por "- ID:", pero sin perder los casos completos
    const caseLines = casesSection.split(/(?=- ID:)/)
      .map(line => line.trim())
      .filter(line => line.startsWith('- ID:'));

    if (caseLines.length === 0) {
      return "No se encontraron casos pendientes";
    }

    // Procesar cada caso usando expresiones regulares
    return caseLines.map(line => {
      const cleanLine = line.replace(/^- ID:/, '').trim(); // Quitar el inicio '- ID:'
      const fields = cleanLine.split('|').map(f => f.trim());
      
      const extractValue = (fieldRegex) => {
        const match = fieldRegex.exec(line);
        return match ? match[1].trim() : 'No especificado';
      };
      console.log("Línea procesada:", fields[0]); // Para depuración
      const idRegex = /ID:\s*([^|]+)/;
      const centerRegex = /Centro Médico:\s*([^|]+)/;
      const studiesRegex = /Requisitos:\s*([^|]+)/;
      const dateRegex = /Creado:\s*(.*)/;

      // Limpiar la fecha para eliminar residuos (\n, espacios, etc.)
      const rawDate = extractValue(dateRegex);
      const cleanedDate = rawDate.replace(/\s+$/, ''); // Elimina espacios o saltos de línea al final

      return {
        id: extractValue(idRegex),
        center: extractValue(centerRegex),
        studies: extractValue(studiesRegex),
        date: cleanedDate
      };
    });
  } catch (error) {
    console.error("Error procesando casos:", error);
    return "Error al mostrar casos pendientes";
  }
};

  return (
    <div className="masive">
       
      <Toast ref={toast} position="top-center" />

      {/* Contenedor flex para título y botón */}
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '5px',
        padding: '0 10px' // Añade espacio a los lados si es necesario
      }}></div>
      
      <h1 style={{ textAlign: 'center', marginBottom: '20px' }}>Carga Masiva de Casos Médicos</h1>

      <Dialog 
          header="Seleccionar Plantilla" 
          visible={visibleDialog} 
          style={{ width: '400px' }}
          onHide={() => {
            setVisibleDialog(false);
            setSelectedCompanies([]);
          }}
          footer={
            <div>
              <Button 
                label="Cancelar" 
                icon="pi pi-times" 
                className="p-button-textg" 
                onClick={() => {
                  setVisibleDialog(false);
                  setSelectedCompanies([]);
                }} 
              />
              <Button 
                label="Descargar" 
                icon="pi pi-download" 
                className="p-button-infog" 
                onClick={() => {
                  if (selectedCompanies.length === 0) {
                    toast.current.show({
                      severity: 'warn',
                      summary: 'Selección requerida',
                      detail: 'Por favor selecciona al menos una compañía.',
                    });
                    return;
                  }
                  
                  selectedCompanies.forEach(companyId => {
                    handleDownload(companyId);
                  });
                  
                  setVisibleDialog(false);
                  setSelectedCompanies([]);
                }} 
                disabled={selectedCompanies.length === 0}
              />
            </div>
          }
        >
          <div className="p-fluid">
            <div className="p-field">
              <label>Selecciona compañía(s):</label> {/* Cambiado a plural */}
              <div className="p-grid" style={{ marginTop: '1rem' }}>
                {availableCompanies.map((companyId) => (
                  <div key={companyId} className="p-col-12 p-md-6">
                    <div className="p-field-checkbox">
                      <Checkbox
                        inputId={`company-${companyId}`}
                        value={companyId}
                        checked={selectedCompanies.includes(companyId)}
                        onChange={(e) => {
                          const isChecked = e.checked;
                          setSelectedCompanies(
                            isChecked
                              ? [...selectedCompanies, companyId]
                              : selectedCompanies.filter(id => id !== companyId)
                          );
                        }}
                      />
                      <label htmlFor={`company-${companyId}`} style={{ marginLeft: '0.5rem' }}>
                        {companyId === 1 ? 'PDVSA' : companyId === 4 ? 'CVG LABORATORIO' : 'Otra Compañía'}
                      </label>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </Dialog>



      <Button 
        label="Descargar Plantilla" 
        icon="pi pi-download" 
        className="template-download-btn"
        onClick={async () => {
          const companyIds = await fetchCompanyClientId();

          if (companyIds && Array.isArray(companyIds) && companyIds.length > 0) {
            if (companyIds.length === 1) {
              handleDownload(companyIds[0]);
            } else {
              setAvailableCompanies(companyIds);
              setVisibleDialog(true);
            }
          } else {
            toast.current.show({
              severity: 'error',
              summary: 'Error',
              detail: 'No se pudo obtener tu ID de compañía.',
              life: 5000,
            });
          }
        }}
        tooltip="Descargar plantilla específica para su compañía"
      />
          
         
     
        <Button 
          label="Ver Historial" 
          icon="pi pi-clock" 
          className="p-button-secondaryg history-btn" 
          onClick={handleFetchHistory} 
        />

      {/* Barra de progreso */}
      <div className="progress-bar">
        {/* Paso 1 */}
        <div className="progress-step">
          <span className={`progress-circle ${currentStep >= 1 ? 'active' : 'inactive'}`}>1</span>
          <p>Subir Archivo Excel</p>
        </div>

        {/* Línea entre paso 1 y 2 */}
        <div className={`progress-line ${currentStep >= 2 ? 'active' : ''}`}></div>

        {/* Paso 2 */}
        <div className="progress-step">
          <span className={`progress-circle ${currentStep >= 2 ? 'active' : 'inactive'}`}>2</span>
          <p>Editar Datos</p>
        </div>

        {/* Línea entre paso 2 y 3 */}
        <div className={`progress-line ${currentStep >= 3 ? 'active' : ''}`}></div>

        {/* Paso 3 */}
        <div className="progress-step">
          <span className={`progress-circle ${currentStep >= 3 ? 'active' : 'inactive'}`}>3</span>
          <p>Confirmar Envío</p>
        </div>
      </div>
          
      {/* Paso 1: Subir archivo */}
      {currentStep === 1 && (
        <div style={{
          backgroundColor: '#f8f9fa',
          padding: '10px',
          borderRadius: '8px',
          marginBottom: '5px'
        }}>
          <h2 style={{ marginBottom: '5px' }}>Subir Archivo Excel</h2>

          {/* Datos esperados */}
          <div style={{ marginBottom: '20px' }}>
            <p><strong>Datos que esperamos:</strong></p>
            <p>(Podrás editar informacion)</p>
          </div>

          {/* Tabla de ejemplo */}
          <table className="example-table">
            <thead>
              <tr>
                <th>NOMBRE DEL PACIENTE</th>
                <th>CÉDULA DEL TITULAR</th>
                <th>CÉDULA DEL PACIENTE</th>
                <th>TELÉFONO</th>
                <th>TELÉFONO ALTERNATIVO</th>
                <th>FECHA DE NACIMIENTO</th>
                <th>SEXO</th>
                <th>FILIAL</th>
                <th>CLÍNICA</th>
                <th>DIAGNÓSTICO</th>
                <th>REQUERIMIENTOS</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Maria Pérez</td>
                <td>12345678</td>
                <td>12345678</td>
                <td>4241234567</td>
                <td>4241234567</td>
                <td>01/01/1990</td>
                <td>F</td>
                <td>Filial A</td>
                <td>Clínica XYZ</td>
                <td>Consulta general</td>
                <td>Requerimiento 1, Requerimiento 2</td>
              </tr>
            </tbody>
          </table>

          {/* Zona de arrastre */}
          <label
            htmlFor="file-upload"
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
            className={`upload-zone ${dragActive ? 'drag-over' : ''}`}
          >
            <span>📁 Arrastra tu archivo aquí o haz clic para seleccionarlo</span>
            {fileName && <span className="file-name">{fileName}</span>}
          </label>

          {/* Input oculto */}
          <input
            id="file-upload"
            type="file"
            accept=".xlsx, .xls, .xltm"
            onChange={handleFileUpload}
            disabled={isProcessing}
            style={{ display: 'none' }}
            ref={fileInputRef}
          />

          {/* Estado de procesamiento */}
          {isProcessing && <p className="processing-text">Procesando datos... ⏳</p>}
        </div>
    )}

    <Dialog
        header={
          <div className="flex align-items-center">
            <i className="pi pi-exclamation-circle mr-2" style={{ fontSize: '1.5rem', color: 'var(--primary-color)' }} />
            <span>Confirmar Envío Masivo</span>
          </div>
        }
        visible={visibleConfirmDialog}
        style={{ width: '500px' }}
        modal
        footer={confirmDialogFooter}
        onHide={() => setVisibleConfirmDialog(false)}
      >
        <div className="confirmation-content flex flex-column align-items-center">
          <i 
            className="pi pi-cloud-upload" 
            style={{ fontSize: '3rem', color: 'var(--primary-color)', marginBottom: '20px' }} 
          />
          
          <h3 style={{ marginTop: 0, textAlign: 'center' }}>¿Confirmar el envío de casos?</h3>
          
          <div style={{ 
            backgroundColor: 'var(--surface-100)',
            padding: '1rem',
            borderRadius: '10px',
            width: '100%',
            margin: '1rem 0'
          }}>
            <div className="grid">
              <div className="col-4">
                <p className="font-bold">Total de casos:</p>
                <p>{cases.length}</p>
              </div>
              <div className="col-4">
                <p className="font-bold">Pacientes:</p>
                <p>{new Set(cases.map(c => c.processedData.patient.ci)).size}</p>
              </div>
              <div className="col-4">
                <p className="font-bold">Usuario creador: </p>
                <p className="text-sm mt-1 mb-1">{userName || ""}</p>   
              </div>
            </div>
          </div>
          
          <small className="text-color-secondary">
            Verifique que los datos son correctos.
          </small>
        </div>
      </Dialog>

      {currentStep === 2 && renderEditStep()}
      {currentStep === 3 && (
  <div className="p-card" style={{ 
    maxWidth: '700px', 
    margin: '0 auto',
    textAlign: 'center'
  }}>
    {isSubmitting ? (
      <div className="flex flex-column align-items-center justify-content-center" style={{ padding: '2rem' }}>
        <ProgressSpinner />
        <p style={{ marginTop: '1rem' }}>Enviando casos médicos... Por favor espere</p>
      </div>
    ) : (
      <div className="p-card-body">
        <h2 className="p-card-title">Confirmar Envío</h2>
        
        <div className="p-card-content">
          <div className="flex flex-column gap-3">
            <div className="p-2 border-round bg-blue-50 text-center w-full">
              <p className="text-lg font-bold text-blue-600 m-0">{cases.length}</p>
              <p className="text-sm text-blue-800 m-0">Total de casos</p>
            </div>
            <div className="p-2 border-round bg-green-50 text-center w-full">
              <p className="text-lg font-bold text-green-600 m-0">
                {new Set(cases.map((c) => c.processedData.patient.ci)).size}
              </p>
              <p className="text-sm text-green-800 m-0">Pacientes</p>
            </div>
            <div className="p-2 border-round bg-blue-50 text-center w-full">
              <p className="text-lg font-bold text-blue-600 m-0">{userName || ""}</p>
              <p className="text-sm text-blue-800 m-0">Usuario creador</p>
            </div>
          </div>
          
          <div className="flex justify-content-center gap-3 mt-5">
            <Button 
              label="Volver" 
              icon="pi pi-arrow-left" 
              className="p-button-secondary" 
              onClick={() => setCurrentStep(2)} 
            />
            <Button 
              label="Confirmar Envío" 
              icon="pi pi-send" 
              onClick={() => setVisibleConfirmDialog(true)} 
            />
          </div>
          
          <small className="block mt-4 text-color-secondary">
            Revise cuidadosamente los datos antes de confirmar
          </small>
          <small className="block mt-4 text-color-tertiary">
            {headers.length > 0 && (
              console.log('Archivos cargados', excelData.length,'y', headers.length, 'columnas')
            )}
          </small>
          {/* Mostrar errores si existen */}
          
          { errorDetails.length > 0 &&(
            <div style={{ marginTop: '2rem' }}>
              <h3 style={{ color: '#FFA726' }}>Errores en algunos casos:</h3>
              <table className="p-table" style={{ width: '100%', border: '1px solid #eee' }}>
                <thead>
                  <tr>
                    <th>Fila Excel</th>
                    <th>Cédula Paciente</th>
                    <th>Nombre Paciente</th>
                  </tr>
                </thead>
                <tbody>
                  {errorDetails.map((error, index) => (
                    <tr key={index}>
                      <td>{error.caseNumber}</td>
                      <td>{error.patientCi}</td>
                      <td>{error.rawData['NOMBRE_PACIENTE'] || error.rawData['NOMBRE_BENEFICIARIO'] || 'N/A'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    )}
  </div>
)}
    <Dialog 
      header="Casos Duplicados Detectados" 
      visible={duplicateDialogVisible} 
      style={{ width: '700px' }}
      footer={duplicateDialogFooter}
      onHide={() => setDuplicateDialogVisible(false)}
      dismissableMask
    >
      <div className="duplicate-dialog-content">
        <p>Seleccione los casos que desea crear como duplicados:</p>
        
        <div className="duplicate-list">
            {duplicateCases.map((item, index) => {
              const pendingCases = formatPendingCases(item.error);
              const hasCases = Array.isArray(pendingCases) && pendingCases.length > 0;

              return (
                <div key={index} className="duplicate-item p-field-checkbox">
                  <Checkbox 
                    inputId={`duplicate-${index}`}
                    checked={item.selected}
                    onChange={() => handleDuplicateSelection(index)}
                  />
                  <label htmlFor={`duplicate-${index}`}>
                    <strong>Caso #{item.caseNumber}</strong> - CI: {item.patientCi}
                    {item.patientName && ` (${item.patientName})`}
                    
                    <div className="pending-cases-info">
                      {hasCases ? (
                        <>
                          {/* Mostrar mensaje compacto */}
                          <p className="cases-count">
                            {pendingCases.length} caso{pendingCases.length !== 1 ? 's' : ''} pendiente{pendingCases.length !== 1 ? 's' : ''}
                            &nbsp;
                            <button 
                              type="button" 
                              className="p-button-textg"
                              onClick={() => setExpandedCases(prev => ({
                                ...prev,
                                [index]: !prev[index]
                              }))}
                              style={{ fontSize: '0.85rem', padding: '2px 6px' }}
                            >
                              {expandedCases[index] ? 'Ver menos' : 'Ver más'}
                            </button>
                          </p>

                          {/* Mostrar detalles solo si expandedCases[index] es true */}
                          {expandedCases[index] && (
                            <div className="cases-details">
                              {pendingCases.slice(0, 3).map((caseItem, caseIndex) => (
                                <div key={caseIndex} className="case-detail">
                                  <p><strong>ID:</strong> {caseItem.id} | <strong>Centro:</strong> {caseItem.center}</p>
                                  <p><strong>Requerimientos:</strong> {caseItem.studies}</p>
                                  <p><strong>Fecha de creacion:</strong> {caseItem.date}</p>
                                  <p>---------------------------------------------------</p>
                                </div>
                              ))}
                              {pendingCases.length > 3 && (
                                <p className="more-cases">...y {pendingCases.length - 3} casos más</p>
                              )}
                            </div>
                          )}
                        </>
                      ) : (
                        <p className="no-cases">{pendingCases}</p>
                      )}
                    </div>
                  </label>
                </div>
              );
            })}
          </div>
      </div>
    </Dialog>
      

      
      <Dialog 
          header={
            modalView === 'history' 
              ? "Historial de Cargas Masivas" 
              : "Detalles de Carga"
          }
          visible={showHistoryModal}
          onHide={() => {
            setShowHistoryModal(false);
            setModalView('history'); // Reinicia la vista al cerrar
          }}
          style={{ width: '80vw' }}
        >
          {/* Filtros */}
            <div className="filter-containerg" style={{ marginBottom: '1rem', display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
              <div className="p-field">
                <label htmlFor="filterUser">Filtrar por usuario</label>
                <input
                  id="filterUser"
                  type="text"
                  value={filterUser}
                  onChange={(e) => setFilterUser(e.target.value)}
                  placeholder="Nombre de usuario"
                  className="p-inputtext"
                  style={{ width: '200px' }}
                />
              </div>
              <div className="p-field">
                <label htmlFor="filterDate">Filtrar por fecha</label>
                <input
                  id="filterDate"
                  type="date"
                  value={filterDate}
                  onChange={(e) => setFilterDate(e.target.value)}
                  className="p-inputtext"
                  style={{ width: '160px' }}
                />
              </div>
              <div className="p-field" style={{ alignSelf: 'end' }}>
                <Button
                  label="Limpiar"
                  icon="pi pi-times"
                  className="p-button-textg"
                  onClick={() => {
                    setFilterUser('');
                    setFilterDate('');
                  }}
                />
              </div>
            </div>
          {/* Botón Atrás cuando esté en detalles */}
          {modalView === 'details' && (
            <Button
              label="← Volver al Historial"
              icon="pi pi-arrow-left"
              className="p-button-textg"
              onClick={() => setModalView('history')}
              style={{ marginBottom: '1rem' }}
            />
          )}

          {/* Renderizado condicional del contenido */}
          {modalView === 'history' 
            ? renderHistoryContent() 
            : renderDetailsContent()
          }
        </Dialog>

      {/* Modal de Detalles */}

    </div>
  );
 
}

export default ExcelMedicalCasesUploader;